export default ":host {\n  font-size: 3.2rem;\n}\n:host::ng-deep .list > .list-item:not(:last-child) {\n  margin-bottom: 2rem;\n}";